import PropTypes from 'prop-types'

export const intlPropType = PropTypes.shape({
    convertDistUnitFrom: PropTypes.func,
    convertDistUnitTo: PropTypes.func,
    convertEnergyEfficiencyUnitFrom: PropTypes.func,
    convertEnergyEfficiencyUnitTo: PropTypes.func,
    convertEnergyUnitFrom: PropTypes.func,
    convertEnergyUnitTo: PropTypes.func,
    convertFuelEfficiencyUnitFrom: PropTypes.func,
    convertFuelEfficiencyUnitTo: PropTypes.func,
    convertGaseousFuelEfficiencyUnitFrom: PropTypes.func,
    convertGaseousFuelEfficiencyUnitTo: PropTypes.func,
    convertLiquidUnitFrom: PropTypes.func,
    convertLiquidUnitTo: PropTypes.func,
    convertSpeedUnitFrom: PropTypes.func,
    convertSpeedUnitTo: PropTypes.func,
    convertWeightUnitFrom: PropTypes.func,
    convertWeightUnitTo: PropTypes.func,
    convertPowerUnitFrom: PropTypes.func,
    convertPowerUnitTo: PropTypes.func,
    formatAddress: PropTypes.func,
    formatCoordinates: PropTypes.func,
    formatDate: PropTypes.func,
    formatDateOnly: PropTypes.func,
    formatDateOnlyUTC: PropTypes.func,
    formatDuration: PropTypes.func,
    formatEnergyEfficiency: PropTypes.func,
    formatEnergyEfficiencyObject: PropTypes.func,
    formatEnergyUnit: PropTypes.func,
    formatEnergyUnitObject: PropTypes.func,
    formatFuelEfficiency: PropTypes.func,
    formatFuelEfficiencyObject: PropTypes.func,
    formatFullTimeOnly: PropTypes.func,
    formatFullTimeOnlyUTC: PropTypes.func,
    formatGaseousFuelEfficiency: PropTypes.func,
    formatGaseousFuelEfficiencyObject: PropTypes.func,
    formatPower: PropTypes.func,
    formatPowerObject: PropTypes.func,
    formatIsoDuration: PropTypes.func,
    formatKg: PropTypes.func,
    formatKmh: PropTypes.func,
    formatLiters: PropTypes.func,
    formatMessage: PropTypes.func,
    formatMeters: PropTypes.func,
    formatMilliliters: PropTypes.func,
    formatNumber: PropTypes.func,
    formatPercent: PropTypes.func,
    formatPositionFull: PropTypes.func,
    formatPositionShort: PropTypes.func,
    formatRpm: PropTypes.func,
    formatTimeOnly: PropTypes.func,
    getDistUnitObject: PropTypes.func,
    getEnergyEfficiencyUnitObject: PropTypes.func,
    getEnergyUnitObject: PropTypes.func,
    getFuelEfficiencyUnitObject: PropTypes.func,
    getLocale: PropTypes.func,
    replaceStringParameters: PropTypes.func,
    translate: PropTypes.func
})
